import React from 'react';
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import operation_room_kit8net from "../assets/img/EC.webp"
import colorSharp2 from "../assets/img/Shop.jpg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import image from "../assets/img/Google.jpg"
import todo from "../assets/img/TODO.jpg"

export const Projects = () => {

  const project1 = [
    {
      title: " ",
      description: " ",
    },
    {
      title: "E-Commerce Web Design",
      description: "Using React.js",
      imgUrl: colorSharp2,
    },
   
  ];
  const project2 = [
    {
      title: " ",
      description: " ",
    },
    {
      title: "E-Commerce DashBoard",
      description: "Using MERN Stack",
      imgUrl: operation_room_kit8net,
    },
  ];
  const project3 = [
    {
      title: " ",
      description: " ",
    },
    {
      title: "Google Clone",
      description: "Using React.js",
      imgUrl: image,
    },
  ];
  const project4 = [
    {
      title: " ",
      description: " ",
    },
    {
      title: "Google Clone",
      description: "Using React.js",
      imgUrl: todo,
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="fourth">Tab 4</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        <p>•Designed and built a React.js e-commerce site for enhanced user experience.
                          Boosted mobile conversions by through modular design and real-time updates. Collaborated on successful project delivery.</p>
                       <a href='https://sakib-e-commerce-web-design.netlify.app/' id='p'>E-Commerce Web Design Link</a>
                        {
                          project1.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <Row>
                      <p>•Product Management : Add,Edit,And Delete products,Manage Categories.
                         •User Management : Manage user accounts and Profile.
                         •Search and Filtering : Allow users to search for products and apply filters.
                         </p>
                         <a href='https://e-commerce05.netlify.app/' id='z'>E-Commerce_DashBoard</a>
                         <h6></h6>
                        {
                          project2.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                        
                    </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="section">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                    <Row>
                         <p>I developed a Google clone using React.js .The project involved creating a user interface that replicated the
                         Google search engine's design and functionality. The project included implementing a search bar,
                         autocomplete feature, search suggestions, and displaying search results. To develop the project, I used the
                         Google search API to retrieve and display search results on the webpage.</p>
                       <a href='https://sakib-google-clone.netlify.app/' id='g'>Google Clone Link</a>
                      {
                        project3.map((project, index) => {
                          return (
                            <ProjectCard
                              key={index}
                              {...project}
                              />
                          )
                        })
                      }
                  </Row>
                    </Tab.Pane>

                    <Tab.Pane eventKey="fourth">
                    <Row>
                         <p>Developed a MERN stack TODO list app with CRUD operations. •Implemented
                          Node.js and Express.js for the backend, MongoDB for data storage. •Designed a
                         responsive React.js frontend for task management. •Utilized Axios for seamless
                         frontend-backend communication.</p>
                       <a href='https://todo-list-sakib.netlify.app/' id='t'>TODO-List</a>
                      {
                        project4.map((project, index) => {
                          return (
                            <ProjectCard
                              key={index}
                              {...project}
                              />
                          )
                        })
                      }
                  </Row>
                    </Tab.Pane>

                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
